module.exports = __webpack_public_path__ + "img/logo-proximax-sirius-faucet_new.17bb0a03.svg";